var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('b-form-input',{attrs:{"id":`${_vm.label}-input`,"type":"date","value":_vm.value},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }